import { LogActionTypes } from './../constants/ApiConstants';

const intialState = {
    loading: false,
    auditloglist: [],
    loginloglist:[],
    master_data: [],
};

export default (state = intialState, { type, payload }) => {
    switch (type) {
        case LogActionTypes.get_audit_log.REQUEST:
            return {
                ...state,
                loading: true,
            };

            case LogActionTypes.get_login_log.REQUEST:
            return {
                ...state,
                loading: true,
            };

        case LogActionTypes.get_audit_log.SUCCESS:
            return {
                ...state,
                auditloglist: payload,
                loading: false,
            };            
        case LogActionTypes.get_login_log.SUCCESS:
            return {
                ...state,
                loginloglist: payload,
                loading: false,
            };
        case LogActionTypes.get_masterdata.REQUEST:
            return {
                ...state,
                loading: true      
            };
        case LogActionTypes.get_masterdata.SUCCESS:
            return {
                ...state,
                loading: false,
                master_data: payload,
            };
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/modules/Logs/reducers/LogReducer.js